/**
 * Landing Picker — view all 5 design variants.
 */
import { Link } from 'react-router-dom';

const variants = [
  {
    id: 'v1',
    name: 'Kinetic',
    desc: 'Movement-driven. Diagonal photo strip. Stacked oversized words. Parallax depth. Tilted screenshots.',
    font: "'Unbounded', cursive",
    accent: '#2EC4B6',
  },
  {
    id: 'v2',
    name: 'Editorial Noir',
    desc: 'Magazine-editorial. 16vw thin serif hero. Asymmetric grids. Duotone images. Numbered features. Pull-quotes.',
    font: "'Cormorant Garamond', serif",
    accent: '#c9a84c',
  },
  {
    id: 'v3',
    name: 'Immersive',
    desc: 'Photography IS the layout. Full-bleed DJ/crowd shots. Glassmorphism panels. Mix-blend-mode text. Parallax.',
    font: "'Syne', sans-serif",
    accent: '#2EC4B6',
  },
  {
    id: 'v4',
    name: 'Construct',
    desc: 'Exposed structure. Dot-grid background. Monospace labels. 3D cards. Dashed borders. Assembly animations.',
    font: "'Space Mono', monospace",
    accent: '#2EC4B6',
  },
  {
    id: 'v5',
    name: 'Luminous',
    desc: 'Animated mesh gradient. Glowing elements. Gradient-filled text. Floating light orbs. Glass cards with colored borders.',
    font: "'Instrument Serif', serif",
    accent: '#7c3aed',
  },
];

export function LandingPicker() {
  return (
    <div style={{ fontFamily: "'DM Sans', sans-serif", background: '#08080a', color: '#d4d4d8', minHeight: '100vh' }}>
      <div className="max-w-4xl mx-auto px-6 py-20">
        <div className="text-center mb-16">
          <div className="flex items-center justify-center gap-3 mb-6">
            <img src="/eventtools-logo.svg" alt="" className="w-10 h-10" />
          </div>
          <h1 className="text-3xl md:text-4xl font-bold mb-3" style={{ color: '#fafafa', letterSpacing: '-0.03em' }}>
            Landing Page Designs
          </h1>
          <p className="text-sm" style={{ color: '#71717a' }}>5 variants. Pick the one that fits.</p>
        </div>

        <div className="space-y-4">
          {variants.map((v, i) => (
            <Link
              key={v.id}
              to={`/${v.id}`}
              className="group block p-6 rounded-xl transition-all hover:translate-y-[-2px]"
              style={{ background: '#111113', border: '1px solid rgba(255,255,255,0.06)' }}
            >
              <div className="flex items-start justify-between gap-4">
                <div className="flex-1">
                  <div className="flex items-center gap-3 mb-2">
                    <span className="text-xs font-bold px-2 py-0.5 rounded" style={{ background: `${v.accent}15`, color: v.accent }}>
                      V{i + 1}
                    </span>
                    <h2 className="text-lg font-semibold" style={{ fontFamily: v.font, color: '#fafafa' }}>
                      {v.name}
                    </h2>
                  </div>
                  <p className="text-sm" style={{ color: '#71717a' }}>{v.desc}</p>
                </div>
                <div className="flex-shrink-0 text-sm font-medium opacity-0 group-hover:opacity-100 transition-opacity" style={{ color: v.accent }}>
                  View →
                </div>
              </div>
            </Link>
          ))}
        </div>

        <div className="text-center mt-8">
          <Link to="/original" className="text-xs hover:underline" style={{ color: '#3f3f46' }}>
            View original design →
          </Link>
        </div>
      </div>
    </div>
  );
}
